import React from "react";

const InternalServerError: React.FC = () => <>
    500
    </>

export default InternalServerError